import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/cmore/cmore_banner.png";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

const Banner = () => {
  return (
    <div
      className="banner_cmore"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#000" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={5} className="my-auto">
            <StaticImage
              src="../../../images/case-studies/cmore/logo.png"
              alt="TekRevol"
              className="logo_img"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={163}
            />
            <h1>Empowering Construction Commerce with a Robust App Solution</h1>
            {/*<div class="banner_playbtn">*/}
            {/*  <Link to="#">*/}
            {/*    <StaticImage*/}
            {/*      src="../../../images/case-studies/cmore/play.png"*/}
            {/*      alt="TekRevol"*/}
            {/*      layout="constrained"*/}
            {/*      placeholder="blurred"*/}
            {/*      formats={["png"]}*/}
            {/*      width={159}*/}
            {/*      height={52}*/}
            {/*    />*/}
            {/*  </Link>*/}
            {/*  <Link to="#">*/}
            {/*    <StaticImage*/}
            {/*      src="../../../images/case-studies/cmore/appstore.png"*/}
            {/*      alt="TekRevol"*/}
            {/*      className="app_store_btn"*/}
            {/*      layout="constrained"*/}
            {/*      placeholder="blurred"*/}
            {/*      formats={["png"]}*/}
            {/*      width={159}*/}
            {/*      height={52}*/}
            {/*    />*/}
            {/*  </Link>*/}
            {/*</div>*/}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Banner;
